import * as types from '../../../lib/actionTypes.es6';

export var getOrgWebhookTemplatesRequest = function(organizationGuid) {
  return { type: types.GET_ORG_WEBHOOK_TEMPLATES_REQUEST, payload: organizationGuid };
};
export var getOrgWebhookTemplatesSuccess = function(payload) {
  return { type: types.GET_ORG_WEBHOOK_TEMPLATES_SUCCESS, payload: payload };
};
export var getOrgWebhookTemplatesFailure = function(error) {
  return { type: types.GET_ORG_WEBHOOK_TEMPLATES_FAILURE, payload: error };
};

export var createOrgWebhookTemplateRequest = function(payload) {
  return { type: types.CREATE_ORG_WEBHOOK_TEMPLATE_REQUEST, payload: payload };
};
export var createOrgWebhookTemplateSuccess = function(payload) {
  return { type: types.CREATE_ORG_WEBHOOK_TEMPLATE_SUCCESS, payload: payload };
};
export var createOrgWebhookTemplateFailure = function(error) {
  return { type: types.CREATE_ORG_WEBHOOK_TEMPLATE_FAILURE, payload: error };
};
export var resetCreateOrgWebhookTemplateSuccess = function() {
  return { type: types.RESET_CREATE_ORG_WEBHOOK_TEMPLATE_SUCCESS };
};
export var resetCreateOrgWebhookTemplateError = function() {
  return { type: types.RESET_CREATE_ORG_WEBHOOK_TEMPLATE_ERROR };
};

export var updateOrgWebhookTemplateRequest = function(payload) {
  return { type: types.UPDATE_ORG_WEBHOOK_TEMPLATE_REQUEST, payload: payload };
};
export var updateOrgWebhookTemplateSuccess = function(payload) {
  return { type: types.UPDATE_ORG_WEBHOOK_TEMPLATE_SUCCESS, payload: payload };
};
export var updateOrgWebhookTemplateFailure = function(error) {
  return { type: types.UPDATE_ORG_WEBHOOK_TEMPLATE_FAILURE, payload: error };
};
export var resetUpdateOrgWebhookTemplateSuccess = function() {
  return { type: types.RESET_UPDATE_ORG_WEBHOOK_TEMPLATE_SUCCESS };
};
export var resetUpdateOrgWebhookTemplateError = function() {
  return { type: types.RESET_UPDATE_ORG_WEBHOOK_TEMPLATE_ERROR };
};

export var deleteOrgWebhookTemplateRequest = function(payload) {
  return { type: types.DELETE_ORG_WEBHOOK_TEMPLATE_REQUEST, payload: payload };
};
export var deleteOrgWebhookTemplateSuccess = function(payload) {
  return { type: types.DELETE_ORG_WEBHOOK_TEMPLATE_SUCCESS, payload: payload };
};
export var deleteOrgWebhookTemplateFailure = function(error) {
  return { type: types.DELETE_ORG_WEBHOOK_TEMPLATE_FAILURE, payload: error };
};
export var resetDeleteOrgWebhookTemplateSuccess = function() {
  return { type: types.RESET_DELETE_ORG_WEBHOOK_TEMPLATE_SUCCESS };
};
export var resetDeleteOrgWebhookTemplateError = function() {
  return { type: types.RESET_DELETE_ORG_WEBHOOK_TEMPLATE_ERROR };
};
